import type { FaireProductEntity } from "../../entity_types/product";

export const p_6cn92btzdn: FaireProductEntity = {
  token: "p_6cn92btzdn",
  type: "product",
  name: "Gold Puka Shell Pearl Bracelet - Maka",
  brandName: "Ke Aloha Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/4f7b0ac2958a4186c674a031076a34f27f65cbfbaec5d1cfb54b312b8d0035e7.jpeg",
  priceDollars: 55,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b45f4c4f9c4b1a7859fe649c22b242b216113607dda053dff4490c4f0c1bf552.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
